import React, { useEffect, useRef } from "react";

import { Post } from "./post";

import {
  ISpotTopExperiences,
  ISpotTopMustSee,
} from "../../../../types/spotInfo";
import { ISpotToptHotels } from "../../../../types/spotTopHotels";

import { languageCheck } from "@shared/functions";

import { Swiper, SwiperSlide, SwiperRef as SwiperRefType } from "swiper/react";
import { EffectCoverflow } from "swiper";

import "swiper/css";
import "swiper/css/effect-coverflow";
import { useMobileDetect } from "@hooks/index";

interface MapActivitiesProps {
  data: (ISpotTopExperiences & ISpotTopMustSee )[]//& ISpotToptHotels)[];
  activeSlide: number;
  handleCloseSwiper: () => void;
  handleSetActiveMarker: (
    latitude: number,
    longitude: number,
    markerIndex: number
  ) => void;
  activeMarkerCoordinates: {
    langitude: number | undefined;
    latitude: number | undefined;
  };
}

export const MapActivities = ({
  data,
  activeSlide,
  handleCloseSwiper,
  handleSetActiveMarker,
  activeMarkerCoordinates,
}: MapActivitiesProps) => {
  const { isMobile } = useMobileDetect();
  const swiperRef = useRef<SwiperRefType | null>(null);

  useEffect(() => {
    swiperRef?.current?.swiper?.slideTo(activeSlide);
  }, [activeSlide]);

  return (
    <div
      className={
        "absolute left-0 z-50 flex items-center justify-center w-full h-40 bg-transparent rounded-xl " +
        `${isMobile() ? "-bottom-4 bg-transparent" : "-bottom-10 bg-black"}`
      }
    >
      <div
        className={`flex items-center justify-center ${
          isMobile() ? "min-w-[2400px]" : "min-w-[3000px]"
        }`}
      >
        <Swiper
          // initialSlide={activeSlide > 0 ? activeSlide : 0}
          ref={swiperRef}
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 0,
            stretch: 20,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          modules={[EffectCoverflow]}
          className=""
          // rewind
          // loop
          onActiveIndexChange={({ activeIndex }) =>
            handleSetActiveMarker(
              data[activeIndex]?.activity[0]?.latitude,
              data[activeIndex]?.activity[0]?.longitude,
              activeIndex
            )
          }
        >
          {data.map((el, idx) => {
            return (
              <SwiperSlide key={el?.city_id + idx} className="mr-auto">
                <Post
                  title={languageCheck(
                    el?.english_name || el?.name_experience_en ,//|| el?.name_en,
                    el?.spanish_name || el?.name_experience_es ,//|| el?.name_es,
                    el?.french_name || el?.name_experience_fr ,//|| el?.name_fr
                    el?.russian_name || el?.name_experience_ru ,//|| el?.name_fr
                  )}
                  id={
                    el?.spot_top_experience_id
                      ? "btnSpotTopExperienceMap_" + el?.spot_top_experience_id
                      : el?.spot_id
                      ? "btnSpotTopMustSeeMap_" + el?.spot_id
                      : "btnSpotTopMustSeeMap_" + el?.spot_id//"btnSpotTopHotelsMap_" + el?.custom_hotel_id
                  }
                  posts={el?.webposts}
                  data={data}
                  index={idx}
                  price={data?.[idx]?.activity?.reduce(
                    (price, curr) =>
                      isNaN(+price)
                        ? "0"
                        : Number(
                            languageCheck(
                              curr.minimum_price_en,
                              curr.minimum_price_es,
                              curr.minimum_price_fr,
                              curr.minimum_price_ru
                            )
                          ) > Number(price)
                        ? price
                        : curr.minimum_price_en,
                    languageCheck(
                      data?.[idx]?.activity?.[0]?.minimum_price_en,
                      data?.[idx]?.activity?.[0]?.minimum_price_es,
                      data?.[idx]?.activity?.[0]?.minimum_price_fr,
                      data?.[idx]?.activity?.[0]?.minimum_price_ru
                    )
                  )}
                  count={data[idx].activity.length}
                  rating={data[idx].activity.reduce(
                    (rating, curr) =>
                      curr.score_en < rating ? rating : curr.score_en,
                    data[idx]?.activity?.[0]?.score_en
                  )}
                  handleCloseSwiper={handleCloseSwiper}
                  automaticallyPlayVideo={
                    !!el.activity.find((activity) => {
                      return (
                        activity.latitude == activeMarkerCoordinates.latitude &&
                        activity.longitude == activeMarkerCoordinates.langitude
                      );
                    })
                  }
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
